<template>
    <div class="recipes-list">
        <div class="recipes-nav">
            <ul class="nav-tabs">
                <li :class="{ selected: type === 'all' }">
                    <a href="#" @click.prevent="fetch('all')">
                        <span>{{ __('All') }}</span>
                    </a>
                </li>

                <li :class="{ selected: type === 'breakfast' }">
                    <a href="#" @click.prevent="fetch('breakfast')">
                        <span>{{ __('Breakfast') }}</span>
                    </a>
                </li>

                <li :class="{ selected: type === 'snack' }">
                    <a href="#" @click.prevent="fetch('snack')">
                        <span>{{ __('Snack') }}</span>
                    </a>
                </li>

                <li :class="{ selected: type === 'lunch' }">
                    <a href="#" @click.prevent="fetch('lunch')">
                        <span>{{ __('Lunch') }}</span>
                    </a>
                </li>

                <li :class="{ selected: type === 'dinner' }">
                    <a href="#" @click.prevent="fetch('dinner')">
                        <span>{{ __('Dinner') }}</span>
                    </a>
                </li>
            </ul>
        </div>

        <div class="tab-content">
            <div class="tab-pane fade in active">
                <a v-for="meal in meals[type]" :key="meal.id" :href="recipeURL(meal.id)" class="recipe-item">
                    <figure>
                        <img :src="meal.resource" :alt="meal.title" />
                    </figure>

                    <div class="recipe-content">
                        <strong class="recipe-title">{{ meal.title }}</strong>

                        <div class="recipe-footer">
                            <span class="recipe-time">{{ meal.time }} {{ __('min') }}</span>
                            <span>•</span>
                            <span class="recipe-energy">{{ meal.energy }} kJ</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                meals: {},
                type: 'all'
            }
        },
        mounted() {
            this.fetch('all')
        },
        methods: {
            fetch(type) {
                this.type = type

                setTimeout(() => {
                    $('.tab-pane').addClass('fade in active')
                    $('.selected').addClass('active')
                }, 100)

                if (this.meals[type]) return

                axios.get(`/meals/recipes/${type}`).then((r) => {
                    this.$set(this.meals, type, r.data.data)
                })
            },
            recipeURL(id) {
                return `/knowledgebase/receptar/${id}`
            }
        }
    }
</script>
